// extracted by mini-css-extract-plugin
module.exports = {"buyWrap":"Buy_buyWrap__11Uie","buy":"Buy_buy__hrGhQ"};